/**
 * Valida variáveis de ambiente no import. Falhar cedo no boot é melhor do que
 * estourar no meio de uma query Supabase com mensagem críptica.
 */
function required(name) {
  const value = import.meta.env[name]
  if (!value || typeof value !== 'string') {
    throw new Error(
      `[env] Variável obrigatória ausente: ${name}. ` +
        `Configure em apps/portal/.env (ou .env.local em DEV).`,
    )
  }
  return value
}

function optional(name, fallback = '') {
  const value = import.meta.env[name]
  return typeof value === 'string' && value.length > 0 ? value : fallback
}

export const env = {
  SUPABASE_URL: required('VITE_SUPABASE_URL'),
  SUPABASE_ANON_KEY: required('VITE_SUPABASE_ANON_KEY'),
  APP_URL: optional('VITE_APP_URL', typeof window !== 'undefined' ? window.location.origin : ''),
  SENTRY_DSN: optional('VITE_SENTRY_DSN'),
  IS_DEV: !!import.meta.env.DEV,
  IS_PROD: !!import.meta.env.PROD,
}
